import React, { useEffect, useState } from 'react';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import TimerEvent from './timerEvent';
import affiche1Fr from '../../../../../assets/images/affiche1Fr.PNG';
import affiche2Fr from '../../../../../assets/images/affiche2Fr.PNG';
import affiche1Ar from '../../../../../assets/images/affiche1Ar.PNG';
import affiche2Ar from '../../../../../assets/images/affiche2Ar.PNG';
import affiche1En from '../../../../../assets/images/affiche1En.PNG';
import affiche2En from '../../../../../assets/images/affiche2En.PNG';
import motDoyen from '../../../../../assets/videos/doyen.mp4';
import { langSelector } from '../../../../../store/langSlice';
import { getLang } from '../../../../../environnement';
import { Tooltip } from '@mui/material';

export default function WordcupEvent() {
  const navigate = useNavigate();
  const lang = useSelector(langSelector);

  const [affiche, setAffiche] = useState(affiche1Fr);
  const [affiche2, setAffiche2] = useState(affiche2Fr);
  const [afficheLink, setAfficheLink] = useState('./affiche/afficheFr.pdf');
  
  useEffect(() => {
    if (lang === 'fr') {
      setAffiche(affiche1Fr);
      setAffiche2(affiche2Fr);
      setAfficheLink('./affiche/afficheFr.pdf');
    } else if (lang === 'ar') {
      setAffiche(affiche1Ar);
      setAffiche2(affiche2Ar);
      setAfficheLink('./affiche/afficheAr.pdf');
    } else {
      setAffiche(affiche1En);
      setAffiche2(affiche2En);
      setAfficheLink('./affiche/afficheAn.pdf');
    }
  }, [lang]);
  return (
    <div>
      <div>
        <p className='text-primary text-2xl xxs:text-3xl font-medium text-center mb-10 mt-16 xxs:mt-0 sm:mt-10'>{getLang(lang).firstWorldCup.alaune}</p>
        <div className=''>
          <p className='text-primary text-xl xxs:text-2xl font-regular text-center mx-10 xxs:mx-0'>{getLang(lang).firstWorldCup.worldcup}</p>
          <div className='w-full flex justify-center my-5'>
            <video src={motDoyen} controls className='w-[90%] sm:w-[1100px] h-[450px] bg-[#121212] border-x-8 border-primary'></video>
          </div>
          <p className='text-primary text-xl xxs:text-2xl font-semiBold text-center mt-14'>{getLang(lang).firstWorldCup.dateWorldcup}</p>
          <TimerEvent primary targetDate='03-07-2025' />
        </div>
       
      </div>
      <div className='bg-primary p-10 xl:flex justify-center items-center hidden'>
        <Tooltip title={getLang(lang).firstWorldCup.telechargerAffiche} onClick={() => window.open(afficheLink, "_blank")}>
          <img src={affiche} alt='affiche' className='w-[300px] cursor-pointer relative hover:bottom-0.5'/>
        </Tooltip>
        <div className='w-[500px] mx-10 flex flex-col items-center'>
          <p className='text-white text-3xl font-medium text-center mb-5'>{getLang(lang).firstWorldCup.worldcup}</p>
          <p className='text-white text-3xl font-regular text-center'>{getLang(lang).firstWorldCup.firstEdition}</p>
          <p className='text-white text-3xl font-regular text-center mb-5'>{getLang(lang).firstWorldCup.dateWorldcup}</p>
          <div onClick={() => navigate('/worldcup-firstEdition')} className='rounded-[10px] bg-primary hover:bg-primaryDark py-2 px-5 mb-5 cursor-pointer flex justify-between items-center w-[400px] h-[100px] border border-white mt-5' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none'}}>
            <p className='text-white font-regular text-xl' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).firstWorldCup.enSavoirPlus}</p>
            <ArrowRightAltIcon sx={{color: 'white'}} />
          </div>
        </div>
        <Tooltip title={getLang(lang).firstWorldCup.telechargerAffiche} onClick={() => window.open(afficheLink, "_blank")}>
          <img src={affiche2} alt='affiche2' className='w-[300px] cursor-pointer relative hover:bottom-0.5'/>
        </Tooltip>
      </div>
      <div className='bg-primary p-10 flex flex-col items-center xl:hidden'>
        <div className='mx-10'>
          <p className='text-white text-xl xxs:text-3xl font-medium text-center mb-5'>{getLang(lang).firstWorldCup.worldcup}</p>
          <p className='text-white text-xl xxs:text-3xl font-regular text-center'>{getLang(lang).firstWorldCup.firstEdition}</p>
          <p className='text-white text-xl xxs:text-3xl font-regular text-center mb-5'>{getLang(lang).firstWorldCup.dateWorldcup}</p>
        </div>
        <div className='flex gap-5'>
          <Tooltip title={getLang(lang).firstWorldCup.telechargerAffiche} onClick={() => window.open(afficheLink, "_blank")}>
            <img src={affiche} alt='affiche' className='w-[300px] cursor-pointer relative hover:bottom-0.5'/>
          </Tooltip>
          <Tooltip title={getLang(lang).firstWorldCup.telechargerAffiche} onClick={() => window.open(afficheLink, "_blank")}>
            <img src={affiche2} alt='affiche2' className='w-[300px] hidden md:inline cursor-pointer relative hover:bottom-0.5'/>
          </Tooltip>
        </div>
        <div onClick={() => navigate('/worldcup-firstEdition')} className='rounded-[10px] bg-primary hover:bg-primaryDark py-2 px-5 mb-5 cursor-pointer flex justify-between items-center xxs:w-[400px] h-[100px] border border-white mt-5' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none'}}>
          <p className='text-white font-regular text-xl' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).firstWorldCup.enSavoirPlus}</p>
          <ArrowRightAltIcon sx={{color: 'white'}} />
        </div>
      </div>
    </div>
  )
}
